import React from "react";
import { TextField, Autocomplete, SxProps, Theme } from "@mui/material";

interface ByzMuiSelectProps extends Omit<React.ComponentProps<typeof Autocomplete>, 'renderInput'> {
  options: any[];
  label: string;
  value?: any;
  placeholder?: string;
  inputLabel?: string;
  sx?: any;
  size?: "small" | "medium";
  renderInput?: React.ComponentProps<typeof Autocomplete>['renderInput'];
}

const ByzMuiSelect: React.FC<ByzMuiSelectProps> = (props: any) => {
  const { options, label, placeholder, inputLabel, sx, multiple = false, size = "small", ...rest } = props;
  
  const defaultFormControlSx: SxProps<Theme> = {
    "& .MuiInputLabel-root": {
      color: "#2498f3 !important",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#2498f3 !important",
    },
    "& .MuiFormLabel-root": {
      color: "#2498f3 !important",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#2498f3 !important",
    },
    "& .MuiSelect-root": {
      height: size === "small" ? "36px" : "auto",
    },
    "& .MuiOutlinedInput-root": {
      height: size === "small" ? "36px" : "auto",
    },
  };

  const defaultSelectSx: SxProps<Theme> = {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2498f3",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2498f3",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2498f3",
    },
  };

  const mergedSx = { ...defaultFormControlSx, ...defaultSelectSx, ...sx };
  const textFieldLabel = inputLabel || placeholder || "";

  return (
    <Autocomplete
      {...rest}
      options={options}
      getOptionLabel={(option: any) => option?.label ?? ""}
      isOptionEqualToValue={(option: any, value: any) => {
        if (!option || !value) return false;
        const optionValue = option.value ?? option.id;
        const valueValue = value.value ?? value.id ?? value;
        return String(optionValue) === String(valueValue);
      }}
      multiple={multiple}
      size={size}
      sx={mergedSx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={textFieldLabel}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};

export default ByzMuiSelect;
